import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Componente que muestra el itinerario de un vuelo y permite seleccionar una opción.
 */
@Component({
    selector: 'app-am-flight-select-itinerary',
    templateUrl: './am-flight-select-itinerary.component.html',
    styleUrls: ['./am-flight-select-itinerary.component.scss'],
    standalone: false
})
export class AmFlightSelectItineraryComponent implements OnInit {
 /**
   * Datos del vuelo a mostrar.
   */
 @Input('flight') flight: any;
  
 /**
  * Evento emitido cuando se selecciona un vuelo.
  */
 @Output() select: EventEmitter<any> = new EventEmitter();

 /**
  * Indica si la opción de continuar está habilitada.
  */
 validatecontinue: boolean = false;
 
 /**
  * Segmentos del vuelo.
  */
 segments: Array<any> = null;
 
 /**
  * Indica si el vuelo es directo.
  */
 isNonStop: boolean = true;
 
 /**
  * Ciudades de conexión del vuelo.
  */
 connections: string = '';
 
 /**
  * Duración total del vuelo en horas y minutos.
  */
 time;
 
 /**
  * Primer segmento del vuelo.
  */
 firstSegment: any = null;
 
 /**
  * Último segmento del vuelo.
  */
 lastSegment: any = null;
 
 /**
  * Mensaje informativo sobre el tipo de vuelo.
  */
 msj;
 
 /**
  * Copia del vuelo seleccionado con modificaciones.
  */
 flightSeg: any;
  constructor() { }

  ngOnInit(): void {
    for (const element of this.flight.segments) {
      element.type = 'irops';
      element.segment = element;
    }
    this.flightSeg =  this.flight
    this.flightSeg.segments.type = 'irops'
    if (this.flight.segments?.length) {
      this.flight = this.flight
    }

    let hours: number = 0;
    let minutes: number = 0

    this.segments = this.flight.segments;
    this.isNonStop = this.flight.isNonStop //this.flight.segments.legType === 'NON-STOP';
    this.connections = this.connectionCities;

    const totalFlightTimeInHours = Number((this.flight.segments.totalFlightTimeInMinutes / 60).toFixed(1));
    hours = Math.floor(totalFlightTimeInHours);
    minutes = Number(this.flight.segments.totalFlightTimeInMinutes) % 60;

    this.time = this.flight.totalFlightTimeFormatHM //`${hours ? hours + ' h' : ''} ${minutes ? minutes + ' m' : ''}`
    this.firstSegment = this.segments[0];

    const last = this.segments.length
    this.lastSegment = this.segments[last - 1];

    if (this.isNonStop) {
      this.msj = 'srIrops.reviewConfirm.withOutScales'
    } else {
      this.msj = 'srIrops.connecting' 
    }
  }

  /**
   * Método que activa o desactiva la selección del vuelo y emite el evento correspondiente.
   * @param flight Vuelo seleccionado.
   */

  activeContinue(flight) {
    flight.selected = !flight.selected;
    this.select.emit(flight);
  }
/**
   * Obtiene las ciudades de conexión del vuelo.
   * @returns {string} Lista de ciudades de conexión separadas por coma.
   */
  private get connectionCities(): string {
    const filter = this.segments.filter((p, j) => j > 0);
    const map = filter.map((m) => m.departureAirport);
    return map?.join(", ") ?? "";
  }

}
